import { render } from "./ListeStatutCommande.vue?vue&type=template&id=a7a38a20&ts=true"
import script from "./ListeStatutCommande.vue?vue&type=script&lang=ts"
export * from "./ListeStatutCommande.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__